import React from 'react'
import styles from '../Fields.module.css'
import { TextField } from "@mui/material"

const style = {
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            background: "transparent"
        }
    }
}

function Input(props) {
    const { type, placeholder, fieldId, onChange, formData, width, multiLine, rows = 0, value, disabled, cols } = props
    let calcValue = undefined;
    const rowID = fieldId?.split("_")[0]
    const inputID = fieldId?.split("_")[1]

    // Soma vertical: última linha (totalVertical)
    if (rowID === "totalVertical" && inputID !== "total") {
        calcValue = rows
            .filter(r => r.id !== "totalVertical")
            .map(r => formData[`${r.id}_${inputID}`])
            .reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
    }

    // Soma horizontal: última coluna (total)
    if (inputID === "total" && rowID !== "totalVertical") {
        calcValue = cols
            .filter(c => c.id !== "total")
            .map(c => formData[`${rowID}_${c.id}`])
            .reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
    }

    // Soma total geral: total_totalVertical
    if (rowID === "totalVertical" && inputID === "total") {
        calcValue = rows
            .filter(r => r.id !== "totalVertical")
            .map(r => cols
                .filter(c => c.id !== "total")
                .map(c => formData[`${r.id}_${c.id}`])
                .reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
            )
            .reduce((sum, val) => sum + val, 0);
    }

    return (
        <TextField
            sx={{ ...style, width, opacity: (disabled && cols == undefined) ? "0.4" : "1", cursor: disabled ? "not-allowed" : "text" }}
            type={type}
            size='small'
            variant='outlined'
            disabled={disabled}
            rows={rows}
            multiline={multiLine}
            placeholder={placeholder}
            value={formData?.[fieldId] || value || calcValue || ""}
            className={styles.inputs}
            onChange={(event) => { onChange(fieldId, event.target.value) }}
            inputProps={{
                maxLength: 200,
            }}
        />
    )
}

export default Input